import Controller from "./featureManager";

let FeatureManagerController = new Controller();

export {
    FeatureManagerController
}
